import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './ResetPassword.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Tooltip from '@mui/material/Tooltip';
import config from "../../config.js";

const ResetPassword = () => {
    const [resetSuccessful, setResetSuccessful] = useState(false);
    const [form] = Form.useForm();
    const  userID  = localStorage.getItem('userID');
    const navigate = useNavigate();
    const onFinish = async (values) => {
        const {newPassword, confirmNewPassword} = values;
        
        if (newPassword !== confirmNewPassword) {
            window.alert('Passwords do not match');
            return;
        }

        try {
            const response = await fetch(`${config.BASE_URL_IP}/wob/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID, newPassword })
            });

            if (response.ok) {
                setResetSuccessful(true);
                window.alert('Password reset successfully. Please log in with your new password.');
            } else {
                const data = await response.json();
                window.alert(data.message || 'An error occurred while resetting the password.');
            }
        } catch (err) {
            console.error('Failed:', err.message);
            window.alert('An error occurred: ' + err.message);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if (resetSuccessful) {
        return <Navigate to="/workorder/wof/login" />;
    }

    return (
        <div className="reset-password-page">
            <div className="reset-password-box">
                <Form
                    form={form}
                    name="reset-password-form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Tooltip title="back">
                <ArrowBackIcon sx={{cursor:"pointer"}} onClick={()=>{navigate(-2)}} fontSize="large"/>
                    </Tooltip>
                    
                    <p className="form-title">Reset Password</p>
{/*                     
                    <Form.Item
                        name="oldPassword"
                        rules={[{ required: true, message: 'Please input your old password!' }]}
                    >
                        <Input.Password placeholder="Old Password" />
                    </Form.Item> */}

                    <p>Enter your new password</p>
                    <Form.Item
                        name="newPassword"
                        rules={[{ required: true, message: 'Please input your new password!' }]}
                    >
                        <Input.Password placeholder="New Password" />
                    </Form.Item>
                    <Form.Item
                        name="confirmNewPassword"
                        rules={[{ required: true, message: 'Please confirm your new password!' }]}
                    >
                        <Input.Password placeholder="Confirm New Password" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default ResetPassword;
